<template>
	<div id="ag-grid-demo">
		<vx-card :title="taskListName">

			<!-- TABLE ACTION ROW -->
			<div class="flex flex-wrap justify-between items-center">

				<!-- ITEMS PER PAGE -->
				<div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

					<vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
						<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
							<span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ gridApi.getDisplayedRowCount() - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : gridApi.getDisplayedRowCount() }} of {{ gridApi.getDisplayedRowCount() }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>

						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<vs-dropdown-menu>

							<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
								<span>150</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(300)">
								<span>300</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
								<span>500</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>

					<div style="float: right" v-if="displayTaskList">
						<vs-button v-if="this.$checkPermission(101)" style="float:left;" class="ml-6 mt-1" type="border" color="success" @click="activeNewTaskPrompt = true" >{{$t("Add")}}</vs-button>
					</div>


				</div>


				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
					<vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
					<vs-select autocomplete multiple class="selectExample" v-model="selectedColumns">
						<vs-select-item :key="index" :value="item.Field" :text="item.Name" v-for="(item,index) in totalColumnList" />
					</vs-select>
					<vx-tooltip :text="$t('SetVisibleTags')" delay=".5s">
						<vs-button class="ml-3" type="border" icon-pack="feather" icon="icon-tag" color="dark" @click="activePickTagsPrompt = true" />
					</vx-tooltip>
					<vx-tooltip :text="$t('ExpandColumns')" delay=".5s">
						<vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
					</vx-tooltip>
					<vx-tooltip :text="$t('ClearFilters')" delay=".5s">
						<vs-button class="ml-3" type="border" color="danger" @click="clearFilters" icon-pack="feather" icon="icon-x-circle"/>
					</vx-tooltip>
				</div>
			</div>

			<ag-grid-vue
					ref="agGridTable"
					:gridOptions="gridOptions"
					class="ag-theme-material w-100 my-4 ag-grid-table"
					:columnDefs="columnDefs"
					:defaultColDef="defaultColDef"
					:rowData="displayTaskList"
					rowSelection="multiple"
					:animateRows="true"
					domLayout="autoHeight"
					:floatingFilter="true"
					:pagination="true"
					:paginationPageSize="paginationPageSize"
					:suppressPaginationPanel="true">
			</ag-grid-vue>
			<vs-pagination
					:total="totalPages"
					:max="maxPageNumbers"
					v-model="currentPage" />

		</vx-card>
		<router-view>
		</router-view>

		<vs-popup v-if="this.gridApi" :title="$t('Add')" :active.sync="activeNewTaskPrompt" style="z-index: 54000;">
			<vx-card>
				<vs-row vs-w="12" vs-justify="space-around">
					<vs-col vs-w="6" vs-sm="12">
						<p>{{$t("TaskTitle")}}</p>
						<vs-input v-model="taskAddTitle"/>
						<p class="mt-6">{{$t("Client")}}</p>
						<vs-select autocomplete class="selectExample" v-model="taskAddClient">
							<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
						</vs-select>
						<p class="mt-6">{{$t("BranchOffice")}}</p>
						<vs-select autocomplete class="selectExample" v-model="taskAddBranchOffice">
							<vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
						</vs-select>
					</vs-col>
					<vs-col vs-w="6" vs-sm="12">
						<vs-checkbox class="mt-6 mb-6" v-model="assignToYourself">{{$t("TakeTask")}}</vs-checkbox>
						<p class="mt-6">{{$t("Tags")}}</p>
						<v-select class="selectStyle" multiple :options="selectableTags" label="name" v-model="taskAddTags">
							<template slot="option" slot-scope="option">
								<div style="display: flex">
									<vs-chip :color="option.color" style="margin: auto" class="mt-1">
										<p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
									</vs-chip>
								</div>
							</template>
						</v-select>
						<p class="mt-6">{{$t("Priority")}}</p>
						<vs-select autocomplete class="selectExample" v-model="taskAddPriority">
							<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
						</vs-select>
						<p class="mt-6">{{$t("Deadline")}}</p>
						<flat-pickr :config="configDateTimePicker" v-model="taskAddDeadline"/>
					</vs-col>
				</vs-row>

				<p class="mt-6">{{$t("Description")}}</p>
				<vs-textarea v-model="taskAddDescription" class="w-full mb-6" v-bind:style="{height: $calculateTextArea(taskAddDescription)}" />

				<vs-divider/>

				<vs-button :disabled="newTaskButtonDisabled" id="newTaskButton" color="success" class="mt-6; mr-1" @click="addTask">{{$t("Add")}}</vs-button>

			</vx-card>

		</vs-popup>

		<vs-popup v-if="this.gridApi && this.$store.state.tagsArray" :title="$t('Tags')" :active.sync="activePickTagsPrompt">
			<vx-card>
				<vs-table ref="table" v-model="selectedTags" multiple search :data="this.$store.state.tagsArray">

					<template slot="thead">
						<vs-th sort-key="name">{{$t("Name")}}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
						<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

							<vs-td :data="data[index].name">
								<vs-chip class="mr-3" :color="data[index].color">
									<p v-bind:style="{color: data[index].text_color}"><b>{{ data[index].name}}</b></p>
								</vs-chip>
							</vs-td>
						</vs-tr>
						</tbody>
					</template>

				</vs-table>
			</vx-card>
		</vs-popup>

	</div>
</template>

<script>
	import { AgGridVue } from "ag-grid-vue"
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';
	import PriorityRenderer from "./Task/PriorityRenderer";
	import StatusRenderer from "./Task/StatusRenderer";

	import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
	import Task from "./Task";
	import PriorityEditor from "./Task/PriorityEditor";
	import AssignedUserEditor from "./Task/AssignedUserEditor";
	import TimeRenderer from "./Task/TimeRenderer";
	import TaskNameRenderer from "./Task/TaskNameRenderer";
	import DeadlineRenderer from "./Task/DeadlineRenderer";
	import DeadlineEditor from "./Task/DeadlineEditor";

	import vSelect from 'vue-select'

	export default {
		name: 'Tasks',
		components: {
			Task,
			AgGridVue,
			flatPickr,
			PriorityRenderer,
			StatusRenderer,
			PriorityEditor,
			AssignedUserEditor,
			TimeRenderer,
			TaskNameRenderer,
			DeadlineRenderer,
			DeadlineEditor,
			'v-select': vSelect,
		},
		props: {
			taskList: {
				type: Number,
				required: true
			},
		},
		data() {
			return {
				activeNewTaskPrompt: false,
				taskAddTitle: '',
				taskAddClient: '',
				taskAddBranchOffice: '',
				taskAddPriority: '',
				taskAddDeadline: null,
				taskAddDescription: '',
				taskAddTags: [],

				assignToYourself: false,

				newTaskButtonDisabled: false,

				activePickTagsPrompt: false,

				branchOffices: [{}],

				selectedClient: null,

				configDateTimePicker: {
					enableTime: true,
					dateFormat: 'Y-m-d H:i',
					locale: {
						firstDayOfWeek: 1
					}
				},
				selectedTaskId: 0,
				searchQuery: '',
				gridOptions: {
					suppressRowClickSelection: true,
					onCellClicked: (e) => {
						if (e.column.colId === 'title' || e.column.colId === 'client_company_id' || e.column.colId === 'company_task_id') {
							this.selectedTaskId = e.data.id;
							this.$router.push({ name: 'task', params: { id: "" + this.selectedTaskId } })
						}
					},
					onCellValueChanged: (e) => {
						if (e.column.colId === 'priority') {
							this.changeTaskPriority(e.data.id, e.data.priority);
						}else if (e.column.colId === 'company_user_id') {
							if(e.data.company_user_id === 0) return;
							this.assignTask(e.data.id, e.data.company_user_id);
						}else if (e.column.colId === 'deadline') {
							this.changeTaskDeadline(e.data.id, e.data.deadline);
						}
					},
					onRowDataChanged: () => {
						this.$nextTick(() => {
							this.gridColumnApi.autoSizeColumns(['client_company_id', 'title', 'company_user_id', 'status', 'priority', 'added_time', 'deadline', 'user_added', 'tag_list']);
							if(this.columnsWidth < this.tableWidth){
								this.gridApi.sizeColumnsToFit()
							}
						});
					}
				},
				maxPageNumbers: 7,
				gridApi: null,
				gridColumnApi: null,
				defaultColDef: {
					sortable: true,
					editable: false,
					resizable: true,
					suppressMenu: true,
					filterParams: { newRowsAction: 'keep'}
				},
				columnDefs: [
					{
						headerName: "ID",
						field: 'company_task_id',
						filter: true,
						width: 50
					},
					{
						headerName: this.$t("Client"),
						field: 'client_company_id',
						filter: true,
						valueGetter: this.companyValueGetter
					},
					{
						headerName: this.$t("TaskTitle"),
						field: 'title',
						filter: true,
						cellRendererFramework: TaskNameRenderer,
					},
					{
						headerName: this.$t("Status"),
						field: 'status',
						filter: true,
						valueGetter: this.statusValueGetter,
						cellRendererFramework: StatusRenderer,
					},
					{
						headerName: this.$t("Priority"),
						field: 'priority',
						width: 120,
						filter: true,
						editable: true,
						cellRendererFramework: PriorityRenderer,
						cellEditorFramework: PriorityEditor,
						cellStyle: {'background-color': 'rgb(0,0,0,0)'}
					},
					{
						headerName: this.$t("AssignedUser"),
						field: 'company_user_id',
						filter: true,
						editable: true,
						cellEditorFramework: AssignedUserEditor,
						cellStyle: {'background-color': 'rgb(0,0,0,0)'},
						valueGetter: this.userValueGetter
					},
					{
						headerName: this.$t("Added"),
						field: 'added_time',
						filter: true,
						width: 150,
						cellRendererFramework: TimeRenderer,
					},
					{
						headerName: this.$t("Deadline"),
						field: 'deadline',
						filter: true,
						editable: true,
						width: 150,
						cellStyle: {'background-color': 'rgb(0,0,0,0)'},
						cellRendererFramework: DeadlineRenderer,
						cellEditorFramework: DeadlineEditor,
					},
					{
						headerName: this.$t("Adder"),
						field: 'user_added',
						filter: true,
						valueGetter: this.userAddedValueGetter
					},
					{
						headerName: this.$t("Tags"),
						field: 'tag_list',
						filter: true,
					},
				],
				tasks: [],

				totalColumnList: [],
			}
		},
		watch: {
			'$store.state.windowWidth'(val) {
				if(val <= 576) {
					this.maxPageNumbers = 4;
					this.gridOptions.columnApi.setColumnPinned('title', null)
				}
				else this.gridOptions.columnApi.setColumnPinned('title', 'left')
			},
			taskAddClient: function () {
				const thisIns = this;
				this.$http.get('/api/v1/client/' + this.taskAddClient + "/branch_offices")
						.then(function (response) {
							thisIns.branchOffices = response.data;
							thisIns.taskAddBranchOffice = thisIns.branchOffices[0].id
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});

				this.$http.get('/api/v1/client/' + this.taskAddClient)
						.then(function (response) {
							thisIns.selectedClient = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			'$store.state.hiddenTasksColumns'(val) {
				if(this.totalColumnList){
					for(let x = 0; x < this.totalColumnList.length; x++){
						if(val.includes(this.totalColumnList[x].Field)){
							this.gridOptions.columnApi.setColumnVisible(this.totalColumnList[x].Field, false)
						}else{
							this.gridOptions.columnApi.setColumnVisible(this.totalColumnList[x].Field, true)
						}
					}
				}

				this.resizeColumns();
			},
			taskList: function () {
				this.updateTasks();
			},
			selectedTagsEncoded: function () {
				this.updateTasks();
			}

		},
		computed: {
			selectableTags() {

				let tags = [];



				for (let key in this.$store.state.tags) {
					if (this.$store.state.tags.hasOwnProperty(key)){
						if(this.$store.state.tags[key].global){
							tags.push(this.$store.state.tags[key])
						}
					}
				}

				if(this.selectedClient){

					for(let x = 0; x < this.selectedClient.tags.length; x++) {
						if(!tags.includes(this.selectedClient.tags[x])){
							tags.push(this.selectedClient.tags[x]);
						}
					}
				}

				return tags;

			},
			columnsWidth() {
				let total = 0;
				let state = this.gridColumnApi.getColumnState();
				if(state){
					for(let x = 0; x < state.length; x++){
						total += state[x].width
					}
				}

				return total;
			},
			tableWidth() {
			 return this.gridApi.gridPanel.eBodyViewport.clientWidth;
			},
			taskListName() {
				switch (this.taskList) {
					case 0:
						return this.$t("OwnTasks");
					case 1:
						return this.$t("AllTasks");
					case 2:
						return this.$t("UnassignedTasks");
					case 3:
						return this.$t("ClosedTasks");
					case 4:
						return this.$t("PausedTasks");
					default:
						return ""

				}
			},
			displayTaskList() {
				return this.tasks
			},
			paginationPageSize() {
				if(this.gridApi) return this.gridApi.paginationGetPageSize()
				else return 50
			},
			totalPages() {
				if(this.gridApi) return this.gridApi.paginationGetTotalPages()
				else return 0
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
					else return 1
				},
				set(val) {
					if(this.gridApi){
						this.gridApi.paginationGoToPage(val - 1)
					}

				}
			},
			selectedColumns: {
				get() {
					let list = [];
					if(this.totalColumnList){
						for(let x = 0; x < this.totalColumnList.length; x++){
							if(!this.$store.state.hiddenTasksColumns.includes(this.totalColumnList[x].Field)){
								list.push(this.totalColumnList[x].Field)
							}
						}
					}

					return list;
				},
				set(val) {

					let list = [];
					if(this.totalColumnList){
						for(let x = 0; x < this.totalColumnList.length; x++){
							if(!val.includes(this.totalColumnList[x].Field)){
								list.push(this.totalColumnList[x].Field)
							}
						}
					}

					this.$store.commit('SET_HIDDEN_TASKS_COLUMNS', list);
				}
			},
			selectedTags: {
				get() {

					let tags = [];

					if(this.$store.state.tagsArray){
						for(let x = 0; x < this.$store.state.tagsArray.length; x++) {
							if(!this.$store.state.taskDeselectedDisplayTags.includes(this.$store.state.tagsArray[x].id)){
								tags.push(this.$store.state.tagsArray[x]);
							}
						}
					}

					return tags;

				},
				set(val) {

					let disabledTags = [];
					let tagIds = [];
					for(let x = 0; x < val.length; x++) {
						tagIds.push(val[x].id);
					}

					for(let x = 0; x < this.$store.state.tagsArray.length; x++) {
						if(!tagIds.includes(this.$store.state.tagsArray[x].id)){
							disabledTags.push(this.$store.state.tagsArray[x].id);
						}
					}

					this.$store.commit('SET_DESELECTED_TASK_TAGS', disabledTags);

				}
			},
			selectedTagsEncoded() {

				let ids = [];
				for(let x = 0; x < this.selectedTags.length; x++){
					ids.push(this.selectedTags[x].id)
				}

				return btoa(JSON.stringify(ids))

			}
		},
		methods: {
			resizeColumns(){
				this.gridColumnApi.autoSizeColumns(['company_task_id', 'client_company_id', 'title', 'company_user_id', 'status', 'priority', 'added_time', 'deadline', 'user_added', 'tag_list']);
				if(this.columnsWidth < this.tableWidth){
					this.gridApi.sizeColumnsToFit()
				}
			},
			updateSearchQuery(val) {
				this.gridApi.setQuickFilter(val)
			},
			updateTasks() {

				let request = "";
				switch (this.taskList) {
					case 0:
						request = "own";
						break;
					case 1:
						request = "open";
						break;
					case 2:
						request = "unassigned";
						break;
					case 3:
						request = "finished";
						break;
					case 4:
						request = "paused";
						break;
					case 5:
						request = "waitingForConfirmation";
						break;
					default:
						request = "open";

				}

				const thisIns = this;
				thisIns.tasks = [];
				this.$http.get('/api/v1/tasks/' + request + "?tags=" + this.selectedTagsEncoded)
						.then(function (response) {
							thisIns.tasks = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addTask() {

				this.newTaskButtonDisabled = true;

				let companyUser = 0;
				if(this.assignToYourself) {
					companyUser = this.$store.state.userData.id;
				}

				this.$vs.loading({
					background: "primary",
					color: "fff",
					container: "#newTaskButton",
					scale: 0.45
				});

				const thisIns = this;
				this.$http.post('/api/v1/task/', {
					title: thisIns.taskAddTitle,
					description: thisIns.taskAddDescription,
					deadline: thisIns.moment(thisIns.taskAddDeadline).format(),
					priority: thisIns.taskAddPriority,
					client_company_id: thisIns.taskAddClient,
					branch_office_id: Number(thisIns.taskAddBranchOffice),
					company_user_id: Number(companyUser),
					tags: thisIns.taskAddTags,
				}).then(function () {
					thisIns.updateTasks();

					thisIns.$vs.loading.close("#newTaskButton > .con-vs-loading");
					thisIns.newTaskButtonDisabled = false;
					thisIns.activeNewTaskPrompt = false;

					thisIns.assignToYourself = false;

					thisIns.taskAddTitle = "";
					thisIns.taskAddDescription = "";
				}).catch(function (error) {

					thisIns.$vs.loading.close("#newTaskButton > .con-vs-loading");
					thisIns.newTaskButtonDisabled = false;
					thisIns.activeNewTaskPrompt = false;

					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			changeTaskPriority(taskId, priority){
				const thisIns = this;
				this.$http.put('/api/v1/task/' + taskId + "/priority/" + priority)
						.then(function () {
							thisIns.updateTasks()
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			assignTask(taskId, userId){
				const thisIns = this;
				this.$http.put('/api/v1/task/' + taskId + "/assign/" + userId)
						.then(function () {
							thisIns.updateTasks()
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			changeTaskDeadline(taskId, deadline){
				const thisIns = this;
				this.$http.put('/api/v1/task/' + taskId + "/deadline/", {
					deadline: thisIns.moment(deadline).format()
				})
						.then(function () {
							thisIns.updateTasks()
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			companyValueGetter(param){
				if(this.$store.getters.companyClients[param.data.client_company_id] === undefined) return "";
				return this.$store.getters.companyClients[param.data.client_company_id].name
			},
			userValueGetter(param){
				if(this.$store.getters.companyUsers[param.data.company_user_id] === undefined || param.data.company_user_id === 0) return "";
				return this.$store.getters.companyUsers[param.data.company_user_id].name
			},
			userAddedValueGetter(param){
				if(this.$store.getters.companyUsers[param.data.user_added] === undefined || param.data.user_added === 0) return param.data.user_added_name;
				return this.$store.getters.companyUsers[param.data.user_added].name
			},
			statusValueGetter(param){
				switch (param.data.status) {
					case 0:
						return this.$t("Unassigned");
					case 1:
						return this.$t("Open");
					case 2:
						return this.$t("InProgress");
					case 3:
						return this.$t("Waiting");
					case 4:
						return this.$t("SentForConfirmation");
					case 5:
						return this.$t("Confirmed");
					case 6:
						return this.$t("Invoiced");
					default:
						return ""

				}
			},
			clearFilters(){
				this.gridApi.setFilterModel(null);
			}
		},
		mounted() {
			this.gridApi = this.gridOptions.api;
			this.gridColumnApi = this.gridOptions.columnApi;
			this.totalColumnList = [];
			for(let x = 0; x < this.gridColumnApi.columnController.columnDefs.length; x++){
				this.totalColumnList.push({Name: this.gridColumnApi.columnController.columnDefs[x].headerName, Field: this.gridColumnApi.columnController.columnDefs[x].field})
				if(this.$store.state.hiddenTasksColumns.includes(this.gridColumnApi.columnController.columnDefs[x].field)){
					this.gridOptions.columnApi.setColumnVisible(this.gridColumnApi.columnController.columnDefs[x].field, false)
				}else{
					this.gridOptions.columnApi.setColumnVisible(this.gridColumnApi.columnController.columnDefs[x].field, true)
				}
			}
		},

		beforeRouteLeave (to, from, next) {
			if(this.activeNewTaskPrompt){
				this.activeNewTaskPrompt = false;
				next(false)
			}else{
				next()
			}
		},
		activated() {
			this.updateTasks();
		}
	};

</script>
<style lang="scss">

	.vs-popup--content {
		max-height: calc(90vh - 200px)
	}


</style>
